import { useEffect } from 'react'

import { GroupsMap, type MapGroup } from '@components/embeds/GroupsMap'
import { loadFont, setFont } from '@utils/embeds/fonts'

export type PublicGroupsMapProps = {
  groups: MapGroup[]
  googleMapsApiKey: string | null
  country: string
}

const FONT = 'Roboto'

export default function PublicGroupsMap({ groups, googleMapsApiKey, country }: PublicGroupsMapProps) {
  useEffect(() => {
    loadFont(FONT)
    setFont(document.body, FONT)
  }, [])

  return (
    <main>
      <GroupsMap groups={groups} googleMapsApiKey={googleMapsApiKey} country={country} />
    </main>
  )
}
